import { DUPE_API_URL } from '@dupe/common/constants'
import { UserResultCountsResponse } from '@dupe/common/types'
import { useQuery } from '@tanstack/react-query'
import useAuthUser from '~/src/hooks/useAuthUser'
import fetcher from '~/src/lib/fetcher'

/**
 * Hook to fetch user result counts
 * Returns total results and image results counts
 */
const useFetchUserResultCounts = () => {
  const { authUser } = useAuthUser()

  return useQuery<UserResultCountsResponse>({
    queryKey: ['user-result-counts', authUser?.uid],
    queryFn: async () => {
      const resultCounts = await fetcher<UserResultCountsResponse>(
        `${DUPE_API_URL}/api/user/result-counts`,
        {
          method: 'GET',
          authUser,
        }
      )

      return resultCounts
    },
    enabled: !!authUser?.uid,
  })
}

export default useFetchUserResultCounts
